import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import {
  clearAnalyticsContext,
  initGoogleAnalytics,
  isGoogleAnalyticsEnabled,
  setAnalyticsContext,
  trackPageView,
} from '@/lib/analytics';

/**
 * Inicializa GA4 (si hay Measurement ID) y registra page_view en cada ruta SPA.
 * Montar dentro de <Router> y bajo <AuthProvider>.
 */
export function GoogleAnalytics() {
  const location = useLocation();
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isGoogleAnalyticsEnabled()) {
      return;
    }
    initGoogleAnalytics();
  }, []);

  useEffect(() => {
    if (!isGoogleAnalyticsEnabled()) {
      return;
    }
    if (isAuthenticated && user?.organization) {
      setAnalyticsContext({
        organization_id: String(user.organization.id),
        organization_code: user.organization.code || undefined,
        role: user.role?.name || undefined,
      });
      return;
    }
    clearAnalyticsContext();
  }, [isAuthenticated, user]);

  useEffect(() => {
    if (!isGoogleAnalyticsEnabled()) {
      return;
    }
    initGoogleAnalytics();
    const path = `${location.pathname}${location.search}`;
    trackPageView(path);
  }, [location.pathname, location.search]);

  return null;
}
